import React, { useEffect, useState } from "react";
import { SectionTitle } from "./_components/SectionTitle";
import { CustomAccordion } from "./_components/CustomAccordion";
import {
  Breadcrumb,
  BreadcrumbEllipsis,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "src/components/ui/breadcrumb";
import { Link } from "react-router-dom";
import axios from "axios";
import { BaseUrlApi, ErrorMessage } from "../../lib/api";
import { toast } from "sonner";
import LoaderPage from "../../components/LoaderPage";

export default function MainFAQ() {
  const faqs = [
    {
      question: "ماهي منصة علي اكاديمي؟",
      answer:
        "علي أكاديمي هي منصة تعليمية متخصصة في تعليم القرآن الكريم وتجويده بطريقة تفاعلية باستخدام أحدث الوسائل التقنية لمساعدة المتعلمين على تحسين قراءتهم وحفظهم وفهمهم لمعاني القرآن الكريم.",
    },
    {
      question: "كيف يمكنني الاشتراك في المنصة؟",
      answer:
        "يمكنك الاشتراك بسهولة من خلال إنشاء حساب جديد باستخدام بريدك الإلكتروني، ثم اختيار الدورة التي ترغب بها والبدء مباشرة.",
    },
    {
      question: "هل المنصة مجانية أم مدفوعة؟",
      answer:
        "توفر المنصة دورات مجانية ومدفوعة. يمكنك البدء ببعض الدورات المجانية، وفي حال رغبتك في محتوى متقدم أو شهادة، يمكنك الاشتراك في الدورات المدفوعة.",
    },
    {
      question: "هل يوجد معلمون متاحون للدروس المباشرة؟",
      answer:
        "نعم، توفر المنصة معلمين مؤهلين لدروس مباشرة وتفاعلية يمكنك من خلالها طرح الأسئلة والحصول على ملاحظات فورية.",
    },
    {
      question: "هل يمكنني الحصول على شهادة بعد إتمام الدورات؟",
      answer:
        "بالتأكيد، يمكنك الحصول على شهادة إلكترونية عند اجتياز الدورة وإتمام جميع المتطلبات المحددة.",
    },
    {
      question: "هل يمكنني التعلم وفقًا لجدولي الزمني؟",
      answer:
        "نعم، معظم الدورات متاحة بشكل مسجل بحيث يمكنك التعلم في أي وقت يناسبك، وهناك أيضًا بعض الجلسات المباشرة المجدولة مسبقًا.",
    },
    {
      question: "هل هناك دعم فني في حال واجهت مشكلة؟",
      answer:
        "نعم، يوجد فريق دعم فني جاهز لمساعدتك عبر البريد الإلكتروني أو المحادثة الفورية داخل المنصة.",
    },
  ];

  const [FAQ, setFAQ] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchFAQ = async () => {
    try {
      const { data } = await axios.get(
        `${BaseUrlApi}/frequently-asked-questions`
      );
      setFAQ(data.data);
    } catch (error) {
      const result = ErrorMessage(error);
      if (typeof result !== "object") toast("Error", { description: result });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFAQ();
  }, []);

  if (loading) {
    return <LoaderPage title={"Loading FAQ"} />;
  }

  return (
    <div className="space-y-20 max-w-7xl mx-auto px-4 mt-14">
      <div className="space-y-6">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/">الصفحة الرئيسية</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbSeparator />

            <BreadcrumbItem>
              <BreadcrumbPage className="font-semibold">
                الأسئلة الشائعة
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <SectionTitle title={"الأسئلة الشائعة"} />
      </div>
      <CustomAccordion items={FAQ} />
    </div>
  );
}
